import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { httpPost } from "../../services/httpService";
import {
  createNmsClaimUrl,
  createContraceptionClaimUrl,
} from "../../apiUrls/apiUrls";
import { logErrorWithPayload } from "../../services/logService";
const initialState = {
  isCreateNmsClaimLoading: false,
  nmsClaimCreated: false,
  isCreateContraceptionClaimLoading: false,
  contraceptionClaimCreated: false,
};
export const createNmsClaimData = createAsyncThunk(
  "MysNms/createNmsClaimData",
  async (data) => {
    const url = createNmsClaimUrl();
    const respData = await httpPost(url, data);
    return respData;
  },
);
export const createContraceptionClaimData = createAsyncThunk(
  "MysContraception/createContraceptionClaimData",
  async (data) => {
    const url = createContraceptionClaimUrl();
    const respData = await httpPost(url, data);
    return respData;
  },
);
const mysClaimsSlice = createSlice({
  name: "mysClaimsSlice",
  initialState,
  reducers: {
    setCreateNmsClaimLoadingData: (state, action) => {
      state.isCreateNmsClaimLoading = action?.payload || false;
    },
    setCreateContraceptionClaimLoadingData: (state, action) => {
      state.isCreateContraceptionClaimLoading = action?.payload || false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createNmsClaimData.pending, (state) => {
        state.isCreateNmsClaimLoading = true;
      })
      .addCase(createNmsClaimData.fulfilled, (state, action) => {
        state.isCreateNmsClaimLoading = false;
        state.nmsClaimCreated = action?.payload;
      })
      .addCase(createNmsClaimData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.isCreateNmsClaimLoading = false;
      })
      .addCase(createContraceptionClaimData.pending, (state) => {
        state.isCreateContraceptionClaimLoading = true;
      })
      .addCase(createContraceptionClaimData.fulfilled, (state, action) => {
        state.isCreateContraceptionClaimLoading = false;
        state.contraceptionClaimCreated = action?.payload;
      })
      .addCase(createContraceptionClaimData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.isCreateContraceptionClaimLoading = false;
      });
  },
});
export const {
  setCreateNmsClaimLoadingData,
  setCreateContraceptionClaimLoadingData,
} = mysClaimsSlice.actions;
export default mysClaimsSlice.reducer;
